export const CONFIGURATION_STEP = "configuration-step";
export const HEARING_AIDS_STEP = "hearing-aids-step";
export const ACCESSORIES_STEP = "accessories-step";
export const WARRANTIES_STEP = "warranties-step";
export const PRICING_STEP = "pricing-step";

export const LEFT_HEARING_AID_SUBSTEP = "left-hearing-aid-substep";
export const RIGHT_HEARING_AID_SUBSTEP = "right-hearing-aid-substep";
export const BINAURAL_HEARING_AID_SUBSTEP = "binaural-hearing-aid-substep";

export const LEFT_DOME_SUBSTEP = "left-dome-substep";
export const RIGHT_DOME_SUBSTEP = "right-dome-substep";
export const BINAURAL_DOME_SUBSTEP = "binaural-dome-substep";

export const LEFT_EARMOLD_SUBSTEP = "left-earmold-substep";
export const RIGHT_EARMOLD_SUBSTEP = "right-earmold-substep";
export const BINAURAL_EARMOLD_SUBSTEP = "binaural-earmold-substep";

export const LEFT_RECEIVER_SUBSTEP = "left-receiver-substep";
export const RIGHT_RECEIVER_SUBSTEP = "right-receiver-substep";
export const BINAURAL_RECEIVER_SUBSTEP = "binaural-receiver-substep";

export const LEFT_TUBE_SUBSTEP = "left-tube-substep";
export const RIGHT_TUBE_SUBSTEP = "right-tube-substep";
export const BINAURAL_TUBE_SUBSTEP = "binaural-tube-substep";
